/**
 * v6 state styling tokens — UNICA fonte stilistica per gli stati commerciali.
 * Bozza, Inviato, Confermato, Rifiutato, Prova differenziati con triplo segnale:
 * colore + bordo + icona simbolica.
 */
import { Pencil, Mail, Heart, X as XIcon, Sparkles } from "lucide-react";

export const STATE_LABEL = {
  bozza: "Bozza",
  inviato: "Inviato",
  confermato: "Confermato",
  rifiutato: "Rifiutato",
  prova: "Prova",
};

export const STATE_SHORT = {
  bozza: "BZ",
  inviato: "INV",
  confermato: "MAT",
  rifiutato: "RIF",
  prova: "PRV",
};

export const STATE_PILL_CLASS = {
  bozza: "bg-neutral-200 text-neutral-700",
  inviato: "bg-amber-500 text-white",
  confermato: "bg-[#7B6A45] text-white",
  rifiutato: "bg-neutral-400 text-white",
  prova: "bg-violet-500 text-white",
};

export const STATE_CARD_CLASS = {
  bozza: "bg-white border border-dashed border-neutral-500 text-neutral-700 italic",
  inviato: "bg-amber-50 border border-amber-500",
  confermato:
    "bg-gradient-to-br from-[#FFF8EC] to-[#F4E4C3] border-2 border-[#7B6A45] shadow-[0_4px_12px_rgba(123,106,69,0.18)]",
  rifiutato: "bg-neutral-100 border border-neutral-300 opacity-55",
  prova: "bg-violet-50 border border-violet-400",
};

export const STATE_DOT_COLOR = {
  bozza: "#737373",
  inviato: "#F59E0B",
  confermato: "#7B6A45",
  rifiutato: "#9CA3AF",
  prova: "#8B5CF6",
};

export const STATE_ICON = {
  bozza: Pencil,
  inviato: Mail,
  confermato: Heart,
  rifiutato: XIcon,
  prova: Sparkles,
};

/**
 * Tutti gli stati ordinati come compaiono nei filtri. Rifiutato è sempre
 * ultimo perché richiede opt-in esplicito (vedi useAgendaFilters).
 */
export const ALL_STATES = ["bozza", "inviato", "confermato", "prova", "rifiutato"];

/**
 * Stati visibili di default (quando filtro = "Tutti"). Rifiutato escluso.
 */
export const DEFAULT_VISIBLE_STATES = ["bozza", "inviato", "confermato", "prova"];
